export default "__VITE_ASSET__c14776e2__"